import { render, staticRenderFns } from "./IdentifierForm.vue?vue&type=template&id=4cb3dde6"
import script from "./IdentifierForm.vue?vue&type=script&lang=js"
export * from "./IdentifierForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports